import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class guestLoginSetMpinUseCase extends BaseUseCase {
    constructor(loginFLowRepo) {
        super();
        this.loginFLowRepo = loginFLowRepo;
    }
    fetchResult(data) {
        return this.loginFLowRepo.guestLoginSetMpin(data);
    }
}
export default guestLoginSetMpinUseCase;
